import { render, staticRenderFns } from "./KycForm.vue?vue&type=template&id=088db173&scoped=true"
import script from "./KycForm.vue?vue&type=script&lang=js"
export * from "./KycForm.vue?vue&type=script&lang=js"
import style0 from "./KycForm.vue?vue&type=style&index=0&id=088db173&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "088db173",
  null
  
)

export default component.exports